export default __webpack_public_path__ + "static/media/blue-list.79085159.png";